import { useAuthDetailStore } from "../../stores/useAuthStore";

export const ROLES = ["ADMIN", "HR", "MANAGER", "EMPLOYEE"];
export const ROLES_CODE = {
    employee: "EMPLOYEE",
    admin: "ADMIN",
    manager: "MANAGER",
    hr: "HR",
    ceo: "CEO",
    accounting_manager: "ACCOUNTING_MANAGER",
};
export const roles_access = ({ usersPrivileges }) => {
    const detail = useAuthDetailStore?.getState()?.detail;

    // vérifier s'il est en preonboarding
    if (detail?.is_in_preonboarding && !detail?.roles) {
        return true;
    }

    const array_roles = detail?.roles?.map((el) => el?.code);

    const isAuthorized = usersPrivileges?.some((el) =>
        array_roles?.includes(el)
    );

    return isAuthorized;
};
